var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('h2',{staticClass:"title mb-2"},[_vm._v(_vm._s(_vm._f("leftpad")(_vm.min))+" : "+_vm._s(_vm._f("leftpad")(_vm.sec)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }